import { render, staticRenderFns } from "./requestDialog.vue?vue&type=template&id=5a525aee"
import script from "./requestDialog.vue?vue&type=script&lang=js"
export * from "./requestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports